import { render } from "./DxtPackageTopUp.vue?vue&type=template&id=c4cf6ba8&scoped=true"
import script from "./DxtPackageTopUp.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUp.vue?vue&type=script&lang=js"

import "./DxtPackageTopUp.vue?vue&type=style&index=0&id=c4cf6ba8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c4cf6ba8"

export default script